export const parseLink = (
  item: Queries.STRAPI__COMPONENT_CONTENT_BLOCKS_CTA_LINK_BLOCK | null,
) => {
  if (!item) return null;
  const type = item.type;
  let title = "";
  let url = "";
  let label = item.CTA_link_label || "";
  let description = "";
  let image: ImageDataLikeWithPropsForGifs | null = item.CTA_link_image
    ? (item.CTA_link_image?.localFile as ImageDataLikeWithPropsForGifs | null)
    : null;
  let imageURL: string | null = null;
  let id: string | null = item.id;
  let labelRight: string | null = null;
  let border: boolean = true;
  let external: boolean = false;
  let summary: string | null = null;
  let labelOverride: string | null = item.label_override;
  let background: boolean = true;
  let highlighted = item.inverted;

  switch (type) {
    case "external":
      title = item.CTA_link_title || title;
      description = item.CTA_link_label || description;
      url = item.CTA_link_url || url;
      external = url.startsWith("http") ? true : false;
      break;
    case "article":
      if (!item.articles_standard_pages) return null;
      title = item.articles_standard_pages!.Page_title!;
      url = `/article/${item.articles_standard_pages!.slug!}`;
      description = item.articles_standard_pages.Page_basics?.summary!;
      summary = item.articles_standard_pages.Page_basics?.summary!;
      image = image
        ? image
        : item.articles_standard_pages.Page_basics?.Page_media?.ThumbnailImage
        ? (item.articles_standard_pages.Page_basics?.Page_media?.ThumbnailImage
            .localFile as ImageDataLikeWithPropsForGifs | null)
        : null;
      labelRight = item.articles_standard_pages.article_type
        ? item.articles_standard_pages.article_type.name
        : null;
      label = label
        ? label
        : item.articles_standard_pages.Event_info?.Start_date
        ? item.articles_standard_pages.Event_info.Start_date
        : "";
      break;
    case "artist":
      if (!item.artist) return null;
      title = item.artist.name!;
      url = item.artist.artistUrl!;
      break;
    case "artwork":
      if (!item.artwork) return null;
      title = item.artwork.title!;
      url = item.artwork.artworkUrl!;
      const durationArray = item.artwork.length
        ? item.artwork.length?.split(":")
        : [];
      description = `${item.artwork.artist?.name!}, ${item.artwork.year}, ${
        durationArray.length
          ? `${durationArray[1]}'${durationArray[2].split(".")[0]}"`
          : null
      }`;
      imageURL = item.artwork.stillUrl;
      break;
    case "sub_category":
      if (!item.sub_category) return null;
      title = item.sub_category.name || title;
      url = `/${
        item.sub_category.main_category
          ? item.sub_category.main_category.slug
          : "no-main-category"
      }/${item.sub_category.slug}`;
      image = image
        ? image
        : item.sub_category.thumbnail
        ? (item.sub_category.thumbnail
            .localFile as ImageDataLikeWithPropsForGifs | null)
        : null;
      highlighted = highlighted === null ? true : highlighted;
      break;
  }
  // if (!title || !url) return null;
  title = title || "";
  url = url || "#";
  return {
    id,
    type,
    title,
    label,
    description,
    url,
    image,
    labelRight,
    border,
    highlighted,
    external,
    summary,
    labelOverride,
    background,
    imageURL,
  };
};

export const parseSimpleLink = (
  item: Queries.STRAPI__COMPONENT_CONTENT_BLOCKS_SIMPLE_LINK | null,
) => {
  if (!item) return null;
  const type = item.type;
  let title = "";
  let url = "";
  let description = item.sub_text || "";
  let id: string | null = item.id;

  switch (type) {
    case "external":
      title = item.text || title;
      url = item.external_url || url;
      break;
    case "article":
      if (!item.article) return null;
      title = item.article!.Page_title!;
      url = `/article/${item.article!.slug!}`;
      description = item.article.Page_basics?.summary!;
      break;
    case "artist":
      if (!item.artist) return null;
      title = item.artist.name!;
      url = item.artist.artistUrl!;
      break;
    case "artwork":
      if (!item.artwork) return null;
      title = item.artwork.title!;
      url = item.artwork.artworkUrl!;
      const durationArray = item.artwork.length
        ? item.artwork.length?.split(":")
        : [];
      description = `${item.artwork.artist?.name!}, ${item.artwork.year}, ${
        durationArray.length
          ? `${durationArray[1]}'${durationArray[2].split(".")[0]}"`
          : null
      }`;
      break;
    case "sub_category":
      if (!item.sub_category) return null;
      title = item.sub_category.name || title;
      url = `/${item.sub_category.slug}`;
      break;
  }
  if (!title || !url) return null;
  return {
    id,
    type,
    title,
    description,
    url,
  };
};
